import { render } from "./BreakdownComponent.vue?vue&type=template&id=717bae8a&scoped=true&ts=true"
import script from "./BreakdownComponent.vue?vue&type=script&lang=ts"
export * from "./BreakdownComponent.vue?vue&type=script&lang=ts"

import "./BreakdownComponent.vue?vue&type=style&index=0&id=717bae8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717bae8a"]])

export default __exports__